import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Counter } from "@/components/Counter";

export const StatsBar = ({ className = "", variant = "hero", items }) => {
  const { t } = useLang();
  const data = items || t.stats;
  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 rounded-3xl border border-line bg-surface overflow-hidden ${className}`} data-testid={`stats-bar-${variant}`}>
      {data.map((s, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.08, duration: 0.6 }}
          className={`p-6 md:p-8 ${i !== 0 ? "border-l border-line" : ""} ${i === 2 ? "border-l" : ""}`}
          data-testid={`stat-${variant}-${i}`}
        >
          <Counter to={s.value} prefix={s.prefix} suffix={s.suffix} className="font-display font-extrabold text-3xl md:text-4xl text-ink tracking-tight" />
          <div className="mt-1 text-xs md:text-sm text-muted font-medium">{s.label}</div>
        </motion.div>
      ))}
    </div>
  );
};
